import { mount } from '../dom-lifecycle';

mount('[data-bg-image]', function () {
    const bgImage = `background-image: url("${this.dataset.bgImage}")`;
    const extra = this.dataset.bgExtra || '';
    this.style.cssText = `${bgImage}; ${extra}`;
});
